// extracted by mini-css-extract-plugin
export default {"spinner":"BCm2QVIcxFVwSImGgEDs","animated":"iQ3pfo6iuX7WpDmMKAZU","skBouncedelay":"Hjl1Dx5e_tq2mvAGvM7r","bounce1":"e8jUK2d5TgKv7Vduq44J","bounce2":"mWv1Vzyw3tGZobJhazYS"};